<script lang="ts">
  import type { Snippet } from "svelte"
  import ActionBox from "@kontextwerk/web-sdk/ui/layout/ActionBox.svelte"

  const {
    label,
    children = null,
    actions = null,
  }: {
    label: string
    children?: Snippet | null
    actions?: Snippet | null
  } = $props()
</script>

<ActionBox {label} darkMode={false} buttonSnippet={actions ? actionSnippet : null}>
  <div class="workflow-action-box">
    {@render children?.()}
  </div>
</ActionBox>

{#snippet actionSnippet()}
  <div class="workflow-action-box__actions">
    {@render actions?.()}
  </div>
{/snippet}

<style lang="less">
  .workflow-action-box {
    display: flex;
    flex-direction: column;
    gap: 0.8rem;
    color: var(--text-100);

    :global(p) {
      margin: 0;
      line-height: 1.45;
    }
  }

  .workflow-action-box__actions {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-end;
    gap: 0.6rem;
  }
</style>
